import React, { useEffect, useMemo, useRef, useState } from "react";
import Button from "components/form/Button";
import { EyeIcon } from "icons/payments/EyeIcon";
// ICON IMPORTS
import { CardIcon } from "icons/payments/Card";
import { BankIconSm } from "icons/payments/BankIconSm";
import { PaypalIcon } from "icons/dashboard/paypal";
import { CashAppIcon } from "icons/dashboard/cashAppIcon";
import { valuesProps } from "types/paymentMethods";
import expiryDateValidation, {
  checkBankManualFormOrPlaid,
  checkNewPaymentDetails,
  checkOldPaymentDetails,
  decode,
  formatCurrency,
  formatExpirationDate,
  formatMinAndMaxAmount,
  getBankName,
  getCardType,
  getMethod,
  getMethodCode,
  validateCard,
} from "utils/HelperFunctions";
import Drawer from "components/ui-component/SideDrawer";
import PayPreview from "./PayPreview";
import PaymentMethodsComponent from "components/paymentMethod/PaymentMethodsComponent";
import WireTransferIcon from "icons/payments/WireTransferIcon";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "store/hooks";
import PaymentProcessStep2 from "pages/payments/PaymentProcessStep2";
import {
  oldPaymentMethodsGet,
  useBankData,
  useCardData,
  useHasLoadedPaymentMethods,
  useIsDataLoading,
  useOldWalletData,
} from "store/slices/paymentMethodSlice";
import { AddCircleIconBlue } from "utils/icon";
import { filterMethodsAllowedByLink } from "utils/linkPaymentMethods";
import WalletIcon from "icons/payments/WalletIcon";
import { updateOverlayState, useUserData } from "store/slices/authSlice";
import { usePortalSettingsData } from "store/slices/dashboardSlice";
import {
  onSetFinalDisclosureLoading,
  onSetShowDisclosure,
  useIsLogin,
  useShowFinalDisclosure,
} from "store/slices/commonSlice";
import {
  convFeeGet,
  duplicatePaymentGet,
  resetCheckDuplicatePayment,
  resetDuplicateOrder,
  setIsPaymentProcessing,
} from "store/slices/paymentsSlice";
import { useParams } from "react-router-dom";
import DisclosureFinal from "components/makePayment/DisclosureFinal";
import AmazonPay from "icons/dashboard/AmazonPay";
import { useMediaQuery } from "react-responsive";
import CustomTooltip from "components/ui-component/CustomTooltip";
import { initialValues } from "utils/countryAddressList";
import {
  PaymentGateway,
  PaymentMethodList,
  SettingsValue,
} from "types/payments";
import { FormRef } from "types/payments";
import { GooglePaySelection } from "types/paymentLink";
import CustomModal from "components/ui-component/CustomModal";
import { RootState } from "store/store";
import { VerifyStaxCardPaymentParams } from "types/agreement";
import { useTestAttrsFactory } from "utils/testid";
import { useDefaultPaymentMethodView } from "hooks/useDefaultPaymentMethodView";
interface PaymentMethodProps {
  currentStep: number;
  handleNext: (payload: any) => Promise<void>;
  handleBack: () => void;
  verifyStripeCardPayment?: ({
    intent,
    email,
    error,
  }: {
    intent?: string | null;
    email?: string;
    error?: any;
  }) => Promise<void>;
  tempData: any;
  isPaymentLink?: boolean;
  useStripeGooglePay?: boolean;
  useStripeApplePay?: boolean;
  setCardData?: unknown;
  paymentMethods?: string;
  setCurrentStep?: (step: number) => void;
  setCompletedSteps?: (steps: unknown) => void;
  completedSteps?: unknown;
  handleGooglePay?: (tokenData: any, amount: any) => void;
  amount?: number | string;
  createPayPalIntent?: () => Promise<any> | any;
  isGoogleLoading?: boolean;
  isLoading?: boolean;
  orderData?: any;
  selectedMethod: string;
  setSelectedMethod: React.Dispatch<React.SetStateAction<string>>;
  isBankBTNDisabled?: boolean;
  isSecretLoading?: boolean;
  handleApplePay?: (
    success: boolean,
    paymentIntent: any,
    failureMessage?: string
  ) => void | Promise<void>;
  setAmtErr?: React.Dispatch<React.SetStateAction<string | null>>;
  setIsEdit?: React.Dispatch<React.SetStateAction<boolean>>;
  amtErr?: string | null;
  isEdit?: boolean;
  isRecurring?: boolean;
  cashAppRef?: React.RefObject<FormRef>;
  cardRef?: React.RefObject<FormRef>;
  bankRef?: React.RefObject<FormRef>;
  amazonRef?: React.RefObject<FormRef>;
  setStorePayload?: (payload: any) => void;
  tokenData?: GooglePaySelection | null;
  setTokenData?: React.Dispatch<
    React.SetStateAction<GooglePaySelection | null>
  >;
  generalMarkers?: Record<string, string>;
  handlePlaidBankPayment?: (
    val: any,
    isCCTokenAvailable: boolean
  ) => Promise<void>;
  isManualForm?: boolean;
  setIsManualForm?: React.Dispatch<React.SetStateAction<boolean>>;
  setIsLoading?: React.Dispatch<React.SetStateAction<boolean>>;
  setIsGoogleLoading?: React.Dispatch<React.SetStateAction<boolean>>;
  action?: string;
  custom_conv?: string;
  isStaxPayPalLoading?: boolean;
  verifyStaxPayPal?: ({
    transactionId,
    error,
  }: {
    transactionId?: string;
    error?: any;
  }) => Promise<void>;
  verifyStaxPayment?: ({
    cc_token,
    cc_token2,
    x_method,
  }: VerifyStaxCardPaymentParams) => Promise<void>;
  onFinalDisclosureOpen?: () => void;
}

const PaymentMethods = ({
  generalMarkers = { "": "" },
  currentStep,
  handleNext = async () => {},
  handleBack,
  verifyStripeCardPayment = async () => {},
  tempData,
  isPaymentLink = false,
  useStripeGooglePay = false,
  useStripeApplePay = false,
  paymentMethods,
  handleGooglePay,
  amount = 0.0,
  createPayPalIntent = () => {},
  isGoogleLoading = false,
  isLoading = false,
  orderData = null,
  selectedMethod,
  setSelectedMethod,
  setAmtErr = () => {},
  setIsEdit = () => {},
  handleApplePay = () => {},
  amtErr = null,
  isEdit = false,
  isRecurring = false,
  cardRef,
  cashAppRef,
  bankRef,
  amazonRef,
  setStorePayload = () => {},
  tokenData = null,
  setTokenData = () => {},
  handlePlaidBankPayment = async (
    val: any,
    isCCTokenAvailable: boolean
  ): Promise<void> => {
    return Promise.resolve();
  },
  isManualForm = true,
  setIsManualForm = () => {},
  setIsLoading = () => {},
  setIsGoogleLoading = () => {},
  action = "",
  custom_conv = "",
  verifyStaxPayment = async () => {},
  verifyStaxPayPal = async () => {},
  isStaxPayPalLoading = false,
  onFinalDisclosureOpen = () => {},
}: PaymentMethodProps) => {
  const testAttrs = useTestAttrsFactory();
  const userData = useUserData();
  const oldWalletData = useOldWalletData();

  const isLogin = useIsLogin();
  const dispatch = useAppDispatch();
  const portalSettings = usePortalSettingsData();
  const isLessThan590 = useMediaQuery({ query: "(max-width: 590px)" });
  const { id: actionId } = useParams();
  const showFinalDisclosure = useShowFinalDisclosure();
  const disclosureContainerRef = useRef<HTMLDivElement>(null);
  const pendingDisclosureScrollRef = useRef<boolean>(false);
  const initialState = {
    filterParamValue: "",
    filterParam: "search",
    page: 1,
    state: "AL",
    country: "US",
    isrecurring: "oneTime",
    agreementType: "new",
    type: "Amount",
    amount: "0.00",
    new_offer_type: "Amount",
    paymentPlan: { start_date: moment().format("MM/DD/YYYY") },
    selectedCard: {},
    selectedBank: {},
  };
  const cardList = useCardData();
  const bankList = useBankData();
  const [showButtons, setShowButtons] = useState<boolean>(true);
  const [isAddNewCard, setIsAddNewCard] = useState(false);
  const [dataPayment, setDataPayment] = useState<any>(initialState);
  const [values, setValues] = useState<valuesProps>(initialValues);
  const [email, setEmail] = useState<string>("");
  const [cardNumber, setcardNumber] = useState<string>("");
  const [iconType, setIconType] = useState<string>("");
  const [selectedState, setSelectedState] = useState<any>(undefined);
  const [isDateErr, setIsDateErr] = useState<boolean>(false);
  const [bankName, setBankName] = useState<any>("");
  const [bank, setBank] = useState<any>("");
  const [errMsg, setErrMsg] = useState<string | undefined>(undefined);
  const [isRingLoading, setIsRingLoading] = useState<boolean>(false);
  const [numberNotmatchedError, setnumberNotmatchedError] =
    useState<boolean>(false);
  const [isPreview, setIsPreview] = useState<boolean>(false);
  const [isPreviewId, setIsPreviewId] = useState<string>("");
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const [isErr, setIsErr] = useState(-1);
  const [cardErrMsg, setCardErrMsg] = useState("");
  const {
    paymentPermission,
    isFeeLoading,
    conFee,
    payPalOrder,
    isDuplicateOrders,
    duplicateOrdersCount,
    checkedDuplicatePayment,
    generalSettings,
  } = useAppSelector((state: RootState) => state.payment);
  const isDataLoading = useIsDataLoading();
  const hasLoadedPaymentMethods = useHasLoadedPaymentMethods();
  const [savedCardsEmail, setSavedCardsEmail] = useState<string>("");
  useEffect(() => {
    setValues((state) => ({
      ...state,
      x_payment_method: getMethodCode(selectedMethod),
    }));
  }, [selectedMethod]);

  const [paymentMethodList, setPaymentMethodList] = useState<
    PaymentMethodList[]
  >([
    {
      name: "Card",
      icon: <CardIcon />,
    },
    {
      name: "Bank",
      icon: <BankIconSm />,
    },
  ]);

  useEffect(() => {
    // if (paymentMethods) {
    // let methodArr = paymentMethods.split("-");
    const isPayPalSupported =
      action !== "agreement" ||
      paymentPermission?.pp_gateway_name?.name !== PaymentGateway.STAX;

    let updatedArr: any = [];
    // methodArr.forEach((item) => {
    if (
      // item?.toLowerCase() === "cc" &&
      paymentPermission &&
      paymentPermission?.cc_ext_availability === SettingsValue.YES
    ) {
      updatedArr.push({ name: "Card", icon: <CardIcon /> });
    }
    if (
      // item?.toLowerCase() === "ach" &&
      paymentPermission &&
      paymentPermission?.ach_ext_availability === SettingsValue.YES
    ) {
      updatedArr.push({ name: "Bank", icon: <BankIconSm /> });
    }
    if (
      paymentPermission &&
      paymentPermission?.pp_ext_availability === SettingsValue.YES &&
      isPayPalSupported
    ) {
      updatedArr.push({ name: "PayPal", icon: <PaypalIcon /> });
    }
    if (
      action !== "agreement" &&
      paymentPermission &&
      paymentPermission?.wt_ext_availability === SettingsValue.YES
    ) {
      updatedArr.push({ name: "Wire", icon: <WireTransferIcon /> });
    }
    if (
      // item?.toLowerCase() === "capp" &&
      paymentPermission &&
      paymentPermission?.capp_ext_availability === SettingsValue.YES
    ) {
      updatedArr.push({ name: "Cash App Pay", icon: <CashAppIcon /> });
    }
    if (
      // item?.toLowerCase() === "amzp" &&
      paymentPermission &&
      paymentPermission?.amzp_ext_availability === SettingsValue.YES
    ) {
      updatedArr.push({ name: "Amazon Pay", icon: <AmazonPay /> });
    }
    // });
    // On a payment link a method must be allowed by the link as well as by
    // the cluster settings checked above.
    const allowedArr = isPaymentLink
      ? filterMethodsAllowedByLink(updatedArr, paymentMethods)
      : updatedArr;
    setPaymentMethodList(allowedArr);
    if (!allowedArr.some((method: any) => method?.name === "Card")) {
      setSelectedMethod(allowedArr?.[0]?.name);
    }
    // }
  }, [paymentPermission, action, isPaymentLink, paymentMethods]);

  const findBankByRoutingNumber = async (routingNumber: string) => {
    setIsRingLoading(true);
    try {
      let bankObj = await getBankName(routingNumber);
      if (bankObj?.type === "success") {
        setBankName(bankObj?.bank_name);
        setBank(bankObj?.bank_name);
      } else {
        setErrMsg("Invalid routing number");
        setIsRingLoading(false);
      }
    } catch (error) {
      console.log("error =====", error);
      setErrMsg("Invalid routing number");
      setIsRingLoading(false);
    } finally {
      setIsRingLoading(false);
    }
  };

  const handleChangeCard = (e: any, name: string) => {
    dispatch(setIsPaymentProcessing(true));
    let value = { ...values };
    if (name === "x_card_num") {
      let icon = getCardType(e.target.value) || iconType;
      if (icon === "amex") {
        if (e.target.value.length < 18) {
          const cardNumber = e.target.value.replace(/\s/g, "");
          const formattedCardNumber = cardNumber
            .replace(/\D/g, "")
            .replace(/(\d{4})(\d{6})(\d{5})/, "$1 $2 $3");
          setcardNumber(formattedCardNumber);
          // setValues({ ...values, [name]: e.target.value });
          value = { ...values, [name]: e.target.value };
        }
      } else {
        if (e.target.value.length < 20) {
          const cardNumber = e.target.value.replace(/\s/g, "");
          const formattedCardNumber = cardNumber
            .replace(/\D/g, "")
            .replace(/(\d{4})(?=\d)/g, "$1 ");
          setcardNumber(formattedCardNumber);
          // setValues({ ...values, [name]: e.target.value });
          value = { ...values, [name]: e.target.value };
        }
      }
    } else if (name === "x_card_code") {
      if (iconType === "amex") {
        if (e.target.value.length < 5) {
          // setValues({ ...values, [name]: e.target.value });
          value = { ...values, [name]: e.target.value };
        }
      } else {
        if (e.target.value.length < 4) {
          // setValues({ ...values, [name]: e.target.value });
          value = { ...values, [name]: e.target.value };
        }
      }
    } else if (name === "x_exp_date") {
      const inputValue = e.target.value;
      setIsDateErr(false);
      if (inputValue?.length < 6) {
        const isValidDate: any = expiryDateValidation(inputValue);
        const formattedDate = formatExpirationDate(inputValue);
        value = { ...value, [name]: formattedDate };
        !isValidDate?.isValid && inputValue?.length === 5 && setIsDateErr(true);
      }
    } else if (name === "x_country") {
      value = { ...value, [name]: e?.value };
    } else if (name === "x_state") {
      value = { ...value, [name]: e?.name };
    } else {
      value = { ...value, [name]: e.target.value };
    }

    setValues(value);
  };

  const handleChangeBank = (e: any, name: string) => {
    dispatch(setIsPaymentProcessing(true));
    if (name === "routing_number") {
      if (e?.target?.value?.length < 10) {
        setValues({ ...values, [name]: e.target.value });
        setBankName("");
        setBank("");
        setErrMsg(undefined);
        if (e?.target?.value?.length === 9) {
          findBankByRoutingNumber(e?.target?.value);
        }
      }
    } else if (name === "r_account_number") {
      setnumberNotmatchedError(false);
      setValues({ ...values, [name]: e?.target.value });
      if (values?.account_number?.length === e?.target?.value?.length) {
        setnumberNotmatchedError(values?.account_number !== e?.target?.value);
      }
    } else {
      setValues({ ...values, [name]: e?.target?.value });
    }
  };

  useEffect(() => {
    if (!cardNumber) {
      setIconType("");
      setValues({ ...values, card_type: "" });
      return;
    } else {
      setIconType(getCardType(cardNumber));
      setValues({ ...values, card_type: getCardType(cardNumber) });
    }
  }, [cardNumber]);

  const onCloseFunc = () => {
    setIsPreview(false);
    setIsPreviewId("2");
  };

  const scheduleMethod = useMemo(() => {
    return getMethod(isAddNewCard, dataPayment, selectedMethod) || "CC";
  }, [isAddNewCard, dataPayment, selectedMethod]);

  useEffect(() => {
    if (isAddNewCard) {
      let response = checkOldPaymentDetails({ dataPayment });
      setIsDisabled(response);
    } else {
      let response = checkNewPaymentDetails({
        values,
        cc_billing_address: portalSettings?.cc_billing_address,
        cc_billing_addr_mandatory: portalSettings?.cc_billing_addr_mandatory,
        selectedMethod,
        email,
        isErr,
        errMsg,
      });
      setIsDisabled(response);
    }
  }, [selectedMethod, values, email, isAddNewCard, dataPayment, isErr, errMsg]);

  const isStax = useMemo(() => {
    if (
      scheduleMethod === "CC" &&
      paymentPermission?.cc_gateway_name?.name === PaymentGateway.STAX
    ) {
      return true;
    } else if (
      scheduleMethod === "ACH" &&
      paymentPermission?.ach_gateway_name?.name === PaymentGateway.STAX
    ) {
      return true;
    }

    return false;
  }, [scheduleMethod, paymentPermission]);

  const onOldCardDataGet = async () => {
    const slug = decode(actionId || "")?.split("_");
    try {
      let payload = {
        accountid: userData?.data?.accountData?.accountid,
        accounts_id: userData?.data?.accountData?.id,
        cluster_id: slug[1],
      };
      await dispatch(oldPaymentMethodsGet(payload)).unwrap();
    } catch (error: any) {
      console.log("old card data get erro:-->", error?.message);
    }
  };

  const { hasUsableSavedMethods } = useDefaultPaymentMethodView({
    cardList,
    bankList,
    walletList: oldWalletData,
    paymentMethodList,
    paymentPermission,
    isLogin,
    hasLoadedPaymentMethods,
    setShowSavedMethods: setIsAddNewCard,
    setDataPayment,
    selectedMethod,
    setSelectedMethod,
  });

  useEffect(() => {
    if (isLogin && actionId) {
      onOldCardDataGet();
    }
  }, [isLogin, actionId]);

  useEffect(() => {
    const method = getMethod(isAddNewCard, dataPayment, selectedMethod);
    let paymentMethodId = "";
    if (
      method === "CC" &&
      paymentPermission?.cc_gateway_name?.name === PaymentGateway.STAX &&
      isAddNewCard
    ) {
      paymentMethodId = dataPayment?.selectedCard?.cc_token;
    } else if (
      method === "ACH" &&
      paymentPermission?.ach_gateway_name?.name === PaymentGateway.STAX &&
      isAddNewCard
    ) {
      paymentMethodId = dataPayment?.selectedBank?.cc_token;
    }
    const getConvFee = async () => {
      const slug = decode(actionId || "")?.split("_");
      try {
        let params = {
          cluster_id: slug[1],
          state:
            values?.x_state !== ""
              ? values?.x_state
              : userData?.data?.accountData?.state,
          x_method: method,
          phone_number: userData?.data?.accountData?.phone,
          x_amount: amount,
          lead_id: orderData?.lead_id,
          custom_conv: paymentMethodId ? "on" : custom_conv,
          pm_id: paymentMethodId,
        };
        await dispatch(convFeeGet(params)).unwrap();
      } catch (error) {
        console.log("getConvFee error =====", error);
      }
    };
    if (
      !isEdit &&
      !amtErr &&
      Number(amount) > 0 &&
      selectedMethod !== "Wire" &&
      selectedMethod !== "PayPal" &&
      isPaymentLink
    ) {
      getConvFee();
    }
  }, [isEdit, amount, selectedMethod, amtErr, isAddNewCard, dataPayment]);

  const handleOnSubmit = async () => {
    try {
      await handlePaymentLinkPayment();
    } catch (error) {
      console.log("handleOnSubmit error =====", error);
    } finally {
      await dispatch(onSetFinalDisclosureLoading(false));
      await dispatch(onSetShowDisclosure(false));
    }
  };

  const handleAccept = async () => {
    dispatch(setIsPaymentProcessing(true));
    await dispatch(onSetFinalDisclosureLoading(true));
    try {
      if (isAddNewCard) {
        await handleOnSubmit();
      } else {
        switch (selectedMethod) {
          case "Card":
            if (
              paymentPermission?.cc_gateway_name?.name ===
                PaymentGateway.STRIPE &&
              cardRef &&
              cardRef.current
            ) {
              await cardRef.current.callHandleClick();
            } else {
              await handleOnSubmit();
            }
            break;
          case "Amazon Pay":
            if (amazonRef && amazonRef.current) {
              await amazonRef.current.callHandleClick();
            } else {
              await handleOnSubmit();
            }
            break;
          case "Bank":
            let check = checkBankManualFormOrPlaid({
              manual_ach: portalSettings?.manual_ach,
              validate_bank_account: portalSettings?.validate_bank_account,
              isManualForm,
            });
            if (
              (paymentPermission?.ach_gateway_name?.name ===
                PaymentGateway.STRIPE ||
                check) &&
              bankRef &&
              bankRef.current
            ) {
              await bankRef.current.callHandleClick();
            } else {
              await handleOnSubmit();
            }
            break;
          case "Cash App Pay":
            if (cashAppRef && cashAppRef.current) {
              await cashAppRef.current.callHandleClick();
            }
            break;
          case "Wire":
            await handleOnSubmit();
            break;
          case "PayPal":
            if (
              (portalSettings?.payment_agreement_opt === SettingsValue.CUSTOM ||
                portalSettings?.payment_agreement_opt ===
                  SettingsValue.DEFAULT) &&
              !showFinalDisclosure
            ) {
              dispatch(resetDuplicateOrder());
              dispatch(onSetFinalDisclosureLoading(false));
              pendingDisclosureScrollRef.current = true;
              onFinalDisclosureOpen();
              dispatch(onSetShowDisclosure(true));
            } else {
              window.location.href = payPalOrder.url;
            }
            break;
          case "Google Pay":
            await handleGooglePayPayment(
              tokenData?.token,
              tokenData?.total_amount
            );
            break;
          default:
            console.log("selectedMethod =====", selectedMethod);
        }
      }
    } catch (error) {
      console.log("error =====", error);
    } finally {
      dispatch(setIsPaymentProcessing(false));
    }
  };
  useEffect(() => {
    if (isAddNewCard) {
      setShowButtons(true);
    } else {
      if (selectedMethod === "Card") {
        if (
          paymentPermission?.cc_gateway_name?.name === PaymentGateway.STRIPE ||
          paymentPermission?.cc_gateway_name?.name === PaymentGateway.STAX
        ) {
          setShowButtons(false);
        } else {
          setShowButtons(true);
        }
      } else if (selectedMethod === "Bank") {
        let check = checkBankManualFormOrPlaid({
          manual_ach: portalSettings?.manual_ach,
          validate_bank_account: portalSettings?.validate_bank_account,
          isManualForm,
        });
        if (
          paymentPermission?.ach_gateway_name?.name === PaymentGateway.STRIPE ||
          paymentPermission?.ach_gateway_name?.name === PaymentGateway.STAX ||
          check
        ) {
          setShowButtons(false);
        } else {
          setShowButtons(true);
        }
      } else if (selectedMethod === "Wire") {
        setShowButtons(true);
      } else if (selectedMethod === "PayPal") {
        setShowButtons(false);
      } else if (selectedMethod === "Cash App Pay") {
        setShowButtons(false);
      } else if (selectedMethod === "Amazon Pay") {
        setShowButtons(false);
      } else if (selectedMethod === "Google Pay") {
        setShowButtons(true);
      }
    }
  }, [
    selectedMethod,
    isAddNewCard,
    paymentPermission,
    portalSettings,
    isManualForm,
  ]);

  const checkPastAmount = async (method?: string) => {
    try {
      let payload = {
        accounts_id: userData?.data?.accountData?.id,
        payment_method: method
          ? method
          : getMethod(isAddNewCard, dataPayment, selectedMethod),
        amount: amount,
      };
      let res: any = await dispatch(duplicatePaymentGet(payload)).unwrap();
      const { isDuplicateOrders, duplicateOrdersCount } = res?.body?.data;
      if (isDuplicateOrders && duplicateOrdersCount > 0) {
        return false;
      } else {
        return true;
      }
    } catch (error) {
      dispatch(resetDuplicateOrder());
      dispatch(resetCheckDuplicatePayment());
      console.log("error =====", error);
    }
  };

  const handleCheckDisclosureAndDuplicate = async (method?: string) => {
    try {
      let moveAhead = !checkedDuplicatePayment
        ? await checkPastAmount(method)
        : true;
      if (!moveAhead) {
        dispatch(onSetFinalDisclosureLoading(false));
        setIsLoading(false);
        setStorePayload({
          ...values,
          email,
          dataPayment,
          isAddNewCard,
          savedCardsEmail,
        });
        return false;
      } else {
        if (
          (portalSettings?.payment_agreement_opt === SettingsValue.CUSTOM ||
            portalSettings?.payment_agreement_opt === SettingsValue.DEFAULT) &&
          !showFinalDisclosure
        ) {
          setIsLoading(false);
          dispatch(resetDuplicateOrder());
          dispatch(onSetFinalDisclosureLoading(false));
          pendingDisclosureScrollRef.current = true;
          onFinalDisclosureOpen();
          dispatch(onSetShowDisclosure(true));
          setStorePayload({
            ...values,
            email,
            dataPayment,
            isAddNewCard,
            savedCardsEmail,
          });
        } else {
          dispatch(resetDuplicateOrder());
          dispatch(resetCheckDuplicatePayment());
          return true;
        }
      }
    } catch (error) {
      console.log("error =====", error);
    }
  };

  const handlePaymentLinkPayment = async () => {
    dispatch(setIsPaymentProcessing(true));
    setIsLoading(true);
    try {
      let moveAhead = await handleCheckDisclosureAndDuplicate();
      if (!moveAhead) {
        return;
      }
      const payload = {
        ...values,
        email,
        iconType,
        bankName,
        bank,
        isAddNewCard,
        dataPayment,
        savedCardsEmail,
        x_payment_method: getMethod(isAddNewCard, dataPayment, selectedMethod),
      };
      await handleNext(payload);
    } finally {
      dispatch(setIsPaymentProcessing(false));
    }
  };

  const handleAgreementPayment = async () => {
    dispatch(setIsPaymentProcessing(true));
    setIsLoading(true);
    try {
      let moveAhead = await handleCheckDisclosureAndDuplicate();
      if (!moveAhead) {
        setIsLoading(false);
        setStorePayload({
          ...values,
          email,
          dataPayment,
          isAddNewCard,
          savedCardsEmail,
        });
        return;
      }

      await handleNext({
        ...values,
        email,
        dataPayment,
        isAddNewCard,
        savedCardsEmail,
        bankName,
        bank,
      });
    } finally {
      dispatch(setIsPaymentProcessing(false));
    }
  };

  const handleGooglePayPayment = async (tokenData: any, amount: any) => {
    dispatch(setIsPaymentProcessing(true));
    setIsGoogleLoading(true);
    let moveAhead = !checkedDuplicatePayment
      ? await checkPastAmount("GP")
      : true;
    try {
      if (!moveAhead) {
        dispatch(onSetFinalDisclosureLoading(false));
        setSelectedMethod("Google Pay");
        setIsGoogleLoading(false);
        setTokenData({ token: tokenData, total_amount: amount });
      } else {
        if (
          (portalSettings?.payment_agreement_opt === SettingsValue.CUSTOM ||
            portalSettings?.payment_agreement_opt === SettingsValue.DEFAULT) &&
          !showFinalDisclosure
        ) {
          setSelectedMethod("Google Pay");
          setTokenData({ token: tokenData, total_amount: amount });
          setIsGoogleLoading(false);
          dispatch(onSetFinalDisclosureLoading(false));
          dispatch(resetDuplicateOrder());
          pendingDisclosureScrollRef.current = true;
          onFinalDisclosureOpen();
          dispatch(onSetShowDisclosure(true));
        } else {
          dispatch(resetDuplicateOrder());
          dispatch(resetCheckDuplicatePayment());
          if (handleGooglePay) {
            await handleGooglePay(tokenData, amount);
          }
        }
      }
    } catch (error) {
      console.log("handleGooglePayPayment error =====", error);
    } finally {
      dispatch(setIsPaymentProcessing(false));
    }
  };

  const handleApplePayPayment = async (
    success: boolean,
    paymentIntent: any,
    failureMessage?: string
  ) => {
    if (isPaymentLink || !success) {
      await handleApplePay(success, paymentIntent, failureMessage);
      return;
    }

    dispatch(setIsPaymentProcessing(true));
    setIsLoading(true);
    try {
      const moveAhead = !checkedDuplicatePayment
        ? await checkPastAmount("AP")
        : true;
      if (!moveAhead) {
        dispatch(onSetFinalDisclosureLoading(false));
        setSelectedMethod("Apple Pay");
        setTokenData({ token: paymentIntent, total_amount: amount });
        setIsLoading(false);
        return;
      }

      if (
        (portalSettings?.payment_agreement_opt === SettingsValue.CUSTOM ||
          portalSettings?.payment_agreement_opt === SettingsValue.DEFAULT) &&
        !showFinalDisclosure
      ) {
        setSelectedMethod("Apple Pay");
        setTokenData({ token: paymentIntent, total_amount: amount });
        setIsLoading(false);
        dispatch(resetDuplicateOrder());
        dispatch(onSetFinalDisclosureLoading(false));
        pendingDisclosureScrollRef.current = true;
        onFinalDisclosureOpen();
        dispatch(onSetShowDisclosure(true));
        return;
      }

      dispatch(resetDuplicateOrder());
      dispatch(resetCheckDuplicatePayment());
      await handleApplePay(true, paymentIntent);
    } catch (error) {
      console.error("handleApplePayPayment error =====", error);
      await handleApplePay(false, undefined, "Payment failed");
    } finally {
      dispatch(setIsPaymentProcessing(false));
    }
  };

  const { min, max } = formatMinAndMaxAmount(
    generalSettings?.systemSettings,
    userData?.data?.accountData?.balance
  );

  const scrollToDisclosure = () => {
    let parent = disclosureContainerRef.current?.parentElement;

    while (parent) {
      if (parent.scrollHeight > parent.clientHeight) {
        parent.scrollTo({ top: 0, behavior: "auto" });
      }
      parent = parent.parentElement;
    }

    if (disclosureContainerRef.current) {
      disclosureContainerRef.current.scrollIntoView({
        behavior: "auto",
        block: "start",
      });
      return;
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    if (
      isPaymentLink &&
      showFinalDisclosure &&
      pendingDisclosureScrollRef.current
    ) {
      pendingDisclosureScrollRef.current = false;
      requestAnimationFrame(() => {
        scrollToDisclosure();
      });
      window.setTimeout(scrollToDisclosure, 100);
    }
  }, [isPaymentLink, showFinalDisclosure]);

  return (
    <>
      <div
        className={`w-full lg:text-xl font-medium lg:max-w-[640px] ${
          !isPaymentLink ? "lg:border-t lg:border-strokePrimary lg:pt-8" : ""
        } ${isPaymentLink && showFinalDisclosure ? "hidden none" : ""}`}
        {...testAttrs(
          "payment-methods",
          isPaymentLink
            ? "Payment link payment methods"
            : "Agreement payment methods"
        )}
      >
        {!isPaymentLink && (
          <div
            className={`w-full flex flex-wrap justify-between items-center gap-3 ${
              currentStep === 3 ? "pb-5" : "pb-5 lg:pb-0"
            }`}
          >
            <p
              className={`${
                currentStep === 3 ? "text-btnPrimaryActive" : "text-txtPrimary"
              } relative lg:flex lg:h-10 lg:items-center`}
            >
              Payment method
            </p>
            {currentStep === 3 && (
              <div className="flex flex-wrap justify-end items-center lg:gap-4 gap-3">
                {isAddNewCard ? (
                  <p
                    onClick={() => setIsAddNewCard(false)}
                    className="flex shrink-0 gap-2 items-center cursor-pointer xl:text-sm text-xs font-medium text-blue hover:!text-btnPrimaryHover"
                    role="button"
                    tabIndex={0}
                    {...testAttrs(
                      "add-new-payment-method",
                      "Add new payment method"
                    )}
                  >
                    <AddCircleIconBlue size="18" aria-hidden="true" /> Add New
                  </p>
                ) : (
                  // Someone who is not logged in always gets this (it opens
                  // the login): their saved methods are only loaded after it.
                  (hasUsableSavedMethods || !isLogin) && (
                    <p
                      className="xl:text-sm text-xs font-medium items-center text-blue cursor-pointer flex shrink-0 gap-2 hover:!text-btnPrimaryHover"
                      role="button"
                      tabIndex={0}
                      {...testAttrs(
                        "select-saved-payment-method",
                        "Select saved payment method"
                      )}
                      onClick={() => {
                        if (isLogin) {
                          setIsAddNewCard(true);
                        } else {
                          dispatch(updateOverlayState(true));
                        }
                      }}
                    >
                      {isLogin ? (
                        <>
                          <span>
                            <WalletIcon
                              aria-hidden="true"
                              className="group"
                              _className="group-hover:!fill-btnPrimaryHover"
                            />
                          </span>
                          Select saved method
                        </>
                      ) : (
                        <CustomTooltip
                          maxwidth="430px"
                          place="top"
                          id="saved-method"
                          content={`<div class="text-xs leading-[18px] font-normal">Log in to access your saved payment methods</div>`}
                        >
                          <span
                            id="saved-method"
                            className=" flex gap-2 font-medium "
                          >
                            <span>
                              <WalletIcon
                                className="group"
                                _className="group-hover:!fill-btnPrimaryHover"
                              />
                            </span>
                            Select saved method
                          </span>
                        </CustomTooltip>
                      )}
                    </p>
                  )
                )}
                <p
                  className="text-btnPrimaryActive hover:!text-btnPrimaryHover flex shrink-0 items-center gap-2 xl:text-sm text-xs font-medium cursor-pointer"
                  role="button"
                  tabIndex={0}
                  {...testAttrs("preview-payment", "Preview payment")}
                  onClick={() => setIsPreview(true)}
                >
                  <EyeIcon
                    aria-hidden="true"
                    strokeColor="var(--color-btn-primary-active)"
                    size="20"
                  />{" "}
                  Preview
                </p>
              </div>
            )}
          </div>
        )}
        <div
          className={`${
            !isPaymentLink
              ? window.innerWidth > 500
                ? "answerSection w-full"
                : ""
              : ""
          }  ${currentStep === 3 ? "open lg:pb-7 pb-3 " : ""} `}
        >
          {isAddNewCard ? (
            <>
              {isPaymentLink && (
                <div className="w-full flex items-center justify-between pb-5">
                  <p className="lg:text-xl text-base font-medium text-txtPrimary">
                    Payment method
                  </p>
                  <p
                    onClick={() => {
                      dispatch(setIsPaymentProcessing(true));
                      setIsAddNewCard(false);
                    }}
                    className="flex gap-2 items-center cursor-pointer xl:text-sm text-xs  font-medium text-blue hover:!text-btnPrimaryHover "
                    role="button"
                    tabIndex={0}
                    {...testAttrs(
                      "add-new-payment-method",
                      "Add new payment method"
                    )}
                  >
                    <AddCircleIconBlue aria-hidden="true" /> Add New
                  </p>
                </div>
              )}

              <PaymentProcessStep2
                data={dataPayment}
                setData={setDataPayment}
                setCurrentStep={() => {}}
                isDataLoading={isDataLoading}
                currentStep={2}
                walletList={oldWalletData}
                setSavedCardsEmail={setSavedCardsEmail}
                isPaymentLink={isPaymentLink}
                setShowPreview={setIsPreview}
                paymentMethodList={paymentMethodList}
                customClassName="!mb-10"
                setSelectedMethod={setSelectedMethod}
                custom_conv={custom_conv}
              />
            </>
          ) : (
            <PaymentMethodsComponent
              cardData={{
                cardNumber,
                isDateErr,
                isErr,
                cardErrMsg,
                setIconType,
                handleChangeCard,
                validateCard: () =>
                  validateCard({
                    values,
                    iconType,
                    setIsErr,
                    setCardErrMsg,
                    setErrMsg,
                  }),
                iconType,
                showNewStripeCardForm: true,
                setIsAddNewCardMakePayment: setIsAddNewCard,
                isAddNewCardMakePayment: isAddNewCard,
              }}
              bankData={{
                bankName,
                numberNotmatchedError,
                setnumberNotmatchedError,
                handleChangeBank,
                selectedState,
                setSelectedState,
                stripeBankURL: `${window.location.href}?method=bank&amount=${amount}&isRecurring=${isRecurring}&custom_conv=${custom_conv}`,
                isManualForm,
                setIsManualForm,
                handlePlaidBankPayment,
              }}
              paymentConfig={{
                paymentMethodList,
                selectedMethod,
                setSelectedMethod,
                amount,
                isRecurring,
                isPaymentLink,
                isAgreement: !isPaymentLink,
                useStripeGooglePay,
                useStripeApplePay,
                agreementClusterId: orderData?.clusterid,
                agreementLeadId: orderData?.lead_id,
                agreementId: orderData?.id,
                custom_conv,

                isStaxPayPalLoading,
              }}
              paymentHandlers={{
                handleGooglePay: (tokenData: any, amount: any) => {
                  handleGooglePayPayment(tokenData, amount);
                },
                verifyStaxCardBank: verifyStaxPayment,
                createPayPalIntent,
                handleApplePay: handleApplePayPayment,
                handleBack,
                verifyStripeCardPayment,
                setShowPreview: setIsPreview,
                verifyStaxPayPal,
              }}
              paymentUrls={{
                stripeAmazonPayURL: `${window.location.href}?method=amazonPay&amount=${amount}&isRecurring=${isRecurring}&custom_conv=${custom_conv}`,
                cashAppURL: `${window.location.href}?method=cashApp&amount=${amount}&isRecurring=${isRecurring}&custom_conv=${custom_conv}`,
              }}
              formState={{
                values,
                email,
                setEmail,
                errMsg,
                amtErr,
                setAmtErr,
                isRingLoading,
              }}
              paymentGatewayState={{
                isGoogleLoading,
                hasGooglePay: paymentMethods
                  ?.split("-")
                  .some(
                    (method) =>
                      method === "GP" || method === "AP" || method === "CC"
                  ),
              }}
              componentRefs={{
                cashAppRef,
                cardRef,
                bankRef,
                amazonRef,
              }}
              phoneAndAddressConfig={{}}
              noAuthClusterId={decode(actionId || "")?.split("_")[1]}
              description={isPaymentLink ? "One-time" : "Agreement"}
            />
          )}

          {isPaymentLink
            ? showButtons && (
                <div className="flex justify-between mt-10">
                  <Button
                    text={`Pay ${
                      formatCurrency(parseFloat(tempData?.amount) + conFee) ||
                      "0.00"
                    }`}
                    className="w-full"
                    isDisabled={
                      isDisabled ||
                      (amtErr ? true : false) ||
                      Number(amount) < min ||
                      Number(amount) < 1 ||
                      Number(amount) > max ||
                      isFeeLoading ||
                      numberNotmatchedError
                    }
                    isLoading={isLoading}
                    {...testAttrs("pay-payment-link", "Pay payment link")}
                    onClick={async () => {
                      handlePaymentLinkPayment();
                    }}
                    variant="variable"
                  />
                </div>
              )
            : showButtons && (
                <div className="w-full flex flex-col-reverse sm:flex-row bg-white pt-6 mt-6 border-t border-strokePrimary gap-3 justify-between items-stretch sm:items-center">
                  <Button
                    text="Back"
                    variant="white"
                    className="sm:!w-40 w-full"
                    isDisabled={isLoading}
                    {...testAttrs(
                      "back-payment-method",
                      "Go back from payment method"
                    )}
                    onClick={() => {
                      handleBack();
                    }}
                  />
                  <Button
                    text="Confirm"
                    className="sm:!w-40 w-full"
                    isDisabled={isDisabled}
                    isLoading={isLoading}
                    variant="variable"
                    {...testAttrs(
                      "confirm-agreement-payment",
                      "Confirm agreement payment"
                    )}
                    onClick={() => {
                      handleAgreementPayment();
                    }}
                  />
                </div>
              )}
          {!isPaymentLink && showButtons && isLoading && (
            <p
              className="mt-3 text-sm text-txtSecondary leading-[18.23px]"
              role="status"
              {...testAttrs(
                "agreement-processing-note",
                "Agreement processing note"
              )}
            >
              Processing your agreement. This can take up to a minute. Please
              keep this page open.
            </p>
          )}
        </div>
        {!isPaymentLink && (
          <Drawer
            direction="right"
            open={isPreview}
            size={isLessThan590 ? `100vw` : "590px"}
            onClose={onCloseFunc}
            overlayColor="#000"
            lockBackgroundScroll={true}
            enableOverlay={true}
          >
            <div
              className="contents"
              {...testAttrs("agreement-payment-preview-drawer")}
            >
              <PayPreview
                id={isPreviewId}
                setId={setIsPreviewId}
                show={isPreview}
                setShow={setIsPreview}
                onClose={onCloseFunc}
                tempData={tempData}
                orderData={orderData}
                isStax={isStax}
                selectedMethod={scheduleMethod}
                paymentMethodToken={
                  isAddNewCard
                    ? scheduleMethod === "CC"
                      ? dataPayment?.selectedCard?.cc_token
                      : scheduleMethod === "ACH"
                        ? dataPayment?.selectedBank?.cc_token
                        : ""
                    : ""
                }
              />
            </div>
          </Drawer>
        )}
      </div>
      {isPaymentLink && showFinalDisclosure && (
        <div
          ref={disclosureContainerRef}
          className={`max-w-[740px] w-full lg:pt-20 lg:pb-10 lg:px-10 md:p-10 p-5 h-full mx-auto`}
          style={{ scrollMarginTop: "84px" }}
          {...testAttrs("final-disclosure", "Final disclosure")}
        >
          <DisclosureFinal
            generalMarkers={generalMarkers}
            handleAccept={handleAccept}
          />
        </div>
      )}
      <CustomModal
        signModal={false}
        isLoading={false}
        isOpen={isDuplicateOrders && duplicateOrdersCount > 0 && isPaymentLink}
        title="Alert"
        doneText="Complete Payment"
        className="max-w-[600px] w-full h-fit rounded-[10px]"
        cancleText="Cancel"
        onDoneClick={() => {
          dispatch(resetDuplicateOrder());
          handleAccept();
        }}
        onCloseClick={() => {
          dispatch(resetCheckDuplicatePayment());
          dispatch(resetDuplicateOrder());
        }}
        children={
          <React.Fragment>
            <div className="pt-5 lg:text-xl text-txtPrimary lg:leading-[30px] leading-[24px]">
              A similar payment was made in the last 10 minutes. Click 'Complete
              Payment' if this is not a duplicate.
            </div>
          </React.Fragment>
        }
      />
    </>
  );
};

export default PaymentMethods;
